import Request from "../common/request";

//请求方法的封装

// 获取底部信息的列表
export const contactInfo = data =>
  Request.get("/contactInfo/contactinfo/contactInfo", data);

  export const contactDetailInfo = data =>
  Request.get("/contactInfo/contactinfo/detail", data);

  


// WEBPACK FOOTER //
// ./src/api/footer.js